import type { SuperUserCompanyDto } from "@/models/dto/superUserCompanyDto";
import axios from "axios";

export const getSuperUserCompanies = async (): Promise<
  Array<SuperUserCompanyDto>
> => {
  const resp = await axios.get<Array<SuperUserCompanyDto>>(
    "/api/superuser/companies"
  );
  return resp.data;
};

export const selectCompany = async (
  company: SuperUserCompanyDto
): Promise<void> => {
  const resp = await axios.post<SuperUserCompanyDto>(
    "/api/superuser/company",
    company
  );
};
